import React from 'react';
import AppLayout from '@cloudscape-design/components/app-layout';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import Button from '@cloudscape-design/components/button';

import AnalysisView from './AnalysisView';

const RUNBOOK_URL =
  'https://pippin.amazon.dev/architect/UhqU4xgk7l9a?artifact=XP37iaTukKY1';

export default function App(): JSX.Element {
  return (
    <AppLayout
      toolsHide
      navigationHide
      content={
        <ContentLayout
          header={
            <Header
              variant="h1"
              actions={
                <Button
                  iconName="external"
                  iconAlign="right"
                  variant="link"
                  href={RUNBOOK_URL}
                  target="_blank"
                  ariaLabel="Open the FRESHSIGHT runbook in a new tab"
                >
                  Help
                </Button>
              }
            >
              FRESHSIGHT Forecast Analysis
            </Header>
          }
        >
          <AnalysisView />
        </ContentLayout>
      }
    />
  );
}
